var Backbone = require('backbone');
var _ = require('underscore');

require('./Reset.less');


module.exports = Backbone.View.extend({

    el: '.Reset',

    events: {
        'click input': 'resetErrorState',
        'change input': 'resetErrorState',
        'focus  input': 'resetErrorState',
        'input input': 'resetErrorState',

        'click .Reset-buttonReset': 'onResetClick'
    },


    initialize: function () {

    },


    resetErrorState: function (e) {
        $(e.currentTarget)
            .closest('.Reset-inputLine')
            .removeClass('Reset-inputLine--error Reset-inputLine--error-with-input');
    },


    show: function () {
        this.$el.addClass('visible');
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    checkRequired: function (params) {
        var hasError = false;
        var self = this;

        if (!this.$('input[name="password"]').val()) {
            params.focusOnError && this.$('input[name="password"]').focus();
            this.$('input[name="password"]')
                .closest('.Reset-inputLine')
                .addClass('Reset-inputLine--error-with-input');
            hasError = true;

            return;
        }

        if (this.$('input[name="password"]').val() != this.$('input[name="confirm"]').val()) {
            params.focusOnError && this.$('input[name="confirm"]').focus();
            this.$('input[name="confirm"]')
                .closest('.Reset-inputLine')
                .addClass('Reset-inputLine--error-with-input');
            hasError = true;

            return;
        }

        return !hasError;
    },


    getFormData: function () {
        var data = {
            'password':  this.$('input[name="password"]').val(),
            'code':  this.$('input[name="code"]').val()
        };

        return data;
    },


    onResetClick: function () {
        if (!this.checkRequired({focusOnError: true})) return;

        var data = this.getFormData();

        var $button = this.$('.Reset-buttonReset');

        $button.addClass('Button--loading');

        this._xhr && this._xhr.abort();

        //TODO: fix api url
        this._xhr = $.ajax(Urls['submissions:api:forgot']('json'), {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                code: data.code,
                password: data.password
            }),
            success: function (data) {
                $button.removeClass('Button--loading');

                Backbone.history.navigate(Urls['submissions:login'](), {trigger: 'true'});
            }.bind(this),
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    if (e.status == 400) { //bad request
                        alert('Error: ' + e.responseText);
                    } else {
                        alert('Error ' + e.status + ': ' + e.statusText);
                    }
                }

                console.log('error', arguments);
            }.bind(this)
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/Reset/Reset.js
// module id = 109
// module chunks = 0